import axios from 'axios';
import qs from 'qs';
import messages from './messages';
import { nextTick } from 'vue';
import moment from 'moment';
import IMask from 'imask';

import stores from '🔗/stores';

export const message = messages;

export const delay = (time) => new Promise((res) => setTimeout(res, time));

export const retinaMediaQuery =
    '(-webkit-min-device-pixel-ratio: 1.5),\
    (min--moz-device-pixel-ratio: 1.5),\
    (-o-min-device-pixel-ratio: 3/2),\
    (min-resolution: 1.5dppx)';

const paramsSerializer = (params) => qs.stringify(params, { indices: false });

export const baseUrl = `${import.meta.env.VITE_APP_BASE_URL ? import.meta.env.VITE_APP_BASE_URL : ''}`;

export const isValidURL = (str) => {
    try {
        new URL(str);
        return true;
    } catch (_) {
        return false;
    }
}

export const isScrollable = (el) => {
    if (!el) {
        return false;
    }

    const style = window.getComputedStyle(el);
    const overflowY = style.overflowY;
    return (overflowY === 'auto' || overflowY === 'scroll') && el.scrollHeight > el.clientHeight;
}

// Поиск ближайшего скроллящегося родителя
export const findScrollableParent = (el) => {
    while (el && el !== document.body) {
        if (isScrollable(el)) {
            return el;
        }

        el = el.parentElement;
    }
    return null;
}

export const copyText = (text) => {
    if (navigator.clipboard) {
        navigator.clipboard.writeText(text);
    } else {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'absolute';
        textArea.style.left = '-999999px';
        textArea.style.zIndex = -1;

        document.body.prepend(textArea);
        textArea.select();

        try {
            document.execCommand('copy');
        } catch (e) {
        }
    }
};

export const placeOptionList = (payload) => {
    const rect = payload.container.getBoundingClientRect();

    nextTick(() => {
        const options = document.querySelector(payload.options);

        if (!options) {
            return;
        }

        if (isMobile()) {
            return;
        }

        const listRect = options.getBoundingClientRect();

        if (!payload.leftAuto) {
            options.style.left = `${rect.left}px`;
        }
        if (!payload.rightAuto) {
            options.style.right = `${window.innerWidth - rect.right}px`;
        }
        options.style.top =
            rect.bottom + listRect.height + 10 >= window.innerHeight
                ? 'auto'
                : `${rect.bottom + (payload.offset || 0)}px`;
        options.style.bottom =
            rect.bottom + listRect.height + 10 < window.innerHeight ? 'auto' : `${window.innerHeight - rect.top}px`;
    });
};

export const pageSizeOptions = [
    { code: 10, name: 10 },
    { code: 20, name: 20 },
    { code: 30, name: 30 }
];

export const maskArtistCode = {
    // mask: /^[a-zA-Z0-9_]{0,20}$/
    mask: /^[a-zA-Z0-9_-]{0,20}$/
};

export const maskTime = {
    mask: 'HH:MM',
    blocks: {
        HH: {
            mask: IMask.MaskedRange,
            from: 0,
            to: 23,
            maxLength: 2
        },
        MM: {
            mask: IMask.MaskedRange,
            from: 0,
            to: 59,
            maxLength: 2
        }
    }
};

export const maskPreviewTime = {
    mask: 'HH:MM',
    blocks: {
        HH: {
            mask: IMask.MaskedRange,
            from: 0,
            to: 59,
            maxLength: 2
        },
        MM: {
            mask: IMask.MaskedRange,
            from: 0,
            to: 59,
            maxLength: 2
        }
    },
    parse: (str) => {
        const [min, sek] = str.split(':').map(s => s.trim());

        return {
            min: Math.max(Math.min(parseInt(min) || 0, 59), 0),
            sek: Math.max(Math.min(parseInt(sek) || 0, 59), 0)
        }
    },
    format: ({ min, sek }) => {
        return `${ min && min > 9 ? '' : '0' }${ min || 0 }:${ sek && sek > 9 ? '' : '0' }${ sek || 0 }`
    }
};

export const maskISRC = {
    mask: 'AA-SSS-00-00000',
    definitions: {
        A: /[a-zA-Z]/,
        S: /[a-zA-Z0-9]/,
        0: /[0-9]/
    }
};

export const maskISWC = {
    mask: 'T-000.000.000-0',
    definitions: {
        T: /[Tt]/,
        0: /[0-9]/
    }
};

export const maskUPC = {
    mask: '000000000000',
    definitions: {
        0: /[0-9]/
    }
};

export const maskEAN = {
    mask: 'HH',
    blocks: {
        HH: {
            mask: IMask.MaskedRange,
            from: 100000000000,
            to: 9999999999999,
            maxLength: 13
        }
    }
};

// export const maskEAN = {
//     mask: function (value) {
//         console.log(value);
//         if (value.replace(/\D/g, '').length > 12) {
//             return '0000000000000'; // EAN-13
//         }

//         return '000000000000'; // UPC-12
//     },
//     // mask: [
//     //     '0000000000000',   // EAN-13 (13 цифр)
//     //     '000000000000',   // UPC-A (12 цифр)
//     // ],
//     definitions: {
//         0: /[0-9]/
//     }
// };

export async function fetchData({ url, method, data, params, auth = true, formData, contentType, signal, responseType, range, keepalive }) {
    if (!url) {
        return;
    }

    const headers = {};

    if (stores.locale().locale) {
        headers['Lang'] = stores.locale().locale;
    }

    if (range) {
        headers['Range'] = range;
    }

    if (auth) {
        headers['Authorization'] = `Bearer ${ stores.user().token }`;
    }

    if (contentType) {
        headers['Content-Type'] = contentType;
    }

    return await axios({
        baseURL: import.meta.env.VITE_APP_API_URL,
        method,
        url,
        data: formData || data,
        headers,
        signal,
        params,
        responseType,
        // paramsSerializer,
        withCredentials: false,
        keepalive
    });
}

export function numberWithSpaces(x) {
    const parts = x.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
}

export const code = () => {
    return (Math.random() + 1).toString(36).substring(7);
};

export const isMobile = () => {
    if (navigator.userAgentData) {
        const uaData = navigator.userAgentData;
        if (uaData.mobile !== undefined) {
            return uaData.mobile;
        }
    }

    // fallback для старых браузеров
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
        .test(navigator.userAgent);
};


export const formatTime = (ms) => {
    const totalSec = Math.floor(ms / 1000);
    const hrs = Math.floor(totalSec / 3600);
    const mins = Math.floor((totalSec % 3600) / 60);
    const secs = totalSec % 60;

    const pad = (n) => n.toString().padStart(2, '0');

    if (hrs > 0) {
        return `${pad(hrs)}:${pad(mins)}:${pad(secs)}`;
    }

    return `${pad(mins)}:${pad(secs)}`;
};

export const timePeriodPreview = (values, timeEnabled) => {
    if (values?.length !== 2) {
        if (values) {
            return moment(values).format(`${ timeEnabled ? 'HH:mm ' : '' }DD.MM.YYYY`);
        }
        return '';
    }

    const from = moment(values[0]);
    const to = moment(values[1]);

    if (from.isSame(to, 'date')) {
        if (timeEnabled) {
            return `${ from.format('HH:mm') } — ${ to.format('HH:mm') }, ${ from.format('DD MMMM YYYY') }`;
        } else {
            return from.format('DD MMMM YYYY');
        }
    }

    return `${ from.format(`${ timeEnabled ? 'HH:mm ' : '' }DD.MM.YYYY`) } — ${ to.format(`${ timeEnabled ? 'HH:mm ' : '' }DD.MM.YYYY`) }`;
};


const knownSitesList = {
    'spotify.com': 'spotify',
    'youtube.com': 'youtube',
    'youtu.be': 'youtube',
    'instagram.com': 'instagram',
    'facebook.com': 'facebook',
    'vk.com': 'vk',
    't.me': 'telegram',
    'telegram.me': 'telegram',
    'telegram.org': 'telegram',
    'music.yandex.ru': 'yandex-music',
    'music.apple.com': 'apple-music',
    'deezer.com': 'deezer',
    'soundcloud.com': 'soundcloud',
    'bandcamp.com': 'bandcamp',
    'napster.com': 'napster',
    'patreon.com': 'patreon',
    'boosty.to': 'boosty',
    'x.com': 'twitter',
    'twitter.com': 'twitter',
    'tiktok.com': 'tiktok',
    'apple.com': 'apple-music',
    'music.amazon.com': 'amazon-music',
    'amazon.com': 'amazon-music',
    'shazam.com': 'shazam',
    'last.fm': 'lastfm',
    'triller.co': 'triller',
    'snapchat.com': 'snapchat',
    'linkedin.com': 'linkedin',
    'threads.net': 'threads',
    'icons8.com': 'icons8'
};

export const knownSites = new Map(
    Object.entries(knownSitesList).map(([domain, code]) => [code, domain])
);

export const getDomainCode = (url) => {
    try {
        const domain = new URL(url).hostname.replace(/^www\./, '');
        const parts = domain.split('.');
        return parts[0] || code();
    } catch {
        return code();
    }
}

export const detectSiteCode = (url) => {
    try {
        const parsed = new URL(url);
        const host = parsed.hostname.replace(/^www\./, '');

        for (const domain in knownSitesList) {
            if (host.includes(domain)) {
                return knownSitesList[domain];
            }
        }

        return getDomainCode(url);
    } catch {
        return code();
    }
}

export const isInvalidEmail = (email) => {
    if (!email) {
        return false;
    }

    return !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

export const shuffleArray = (array) => {
    const arr = array.slice();
    for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
}

export const shuffleCurrentArray = (items) => {
    for (let i = items.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [items[i], items[j]] = [items[j], items[i]];
    }

    return items;
}

export const createEmitter = () => {
    const events = new Map();

    return {
        on(event, handler) {
            if (!events.has(event)) {
                events.set(event, new Set());
            }
            events.get(event).add(handler);
            return () => this.off(event, handler);
        },
        off(event, handler) {
            if (!events.has(event)) return;
            events.get(event).delete(handler);
        },
        emit(event, ...args) {
            if (!events.has(event)) return;
            for (const h of Array.from(events.get(event))) {
                try {
                    h(...args);
                } catch (e) {
                    console.error('Emitter handler error', e);
                }
            }
        }
    };
};

export const formatDuration = (ms) => {
    if (!ms || ms < 0) {
        return "00:00";
    }

    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const pad = (n) => String(n).padStart(2, "0");

    if (hours > 0) {
        return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    }

    return `${pad(minutes)}:${pad(seconds)}`;
}


let wakeLock;

export const keepAwake = async () => {
    if (wakeLock !== null && document.visibilityState === 'visible') {
        try {
            wakeLock = await navigator.wakeLock.request('screen');
            // console.log('Wake Lock активен');
        } catch (err) {
            // console.error('Не удалось активировать Wake Lock:', err);
        }
    }
}
